var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTool02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.5L10.5 11M6 6.5H3L2 3.5L3 2.5L6 3.5V6.5ZM19.259 3.24101L16.6314 5.86863C16.2354 6.26465 16.0373 6.46265 15.9632 6.69098C15.8979 6.89183 15.8979 7.10817 15.9632 7.30902C16.0373 7.53735 16.2354 7.73535 16.6314 8.13137L16.8686 8.36863C17.2646 8.76465 17.4627 8.96265 17.691 9.03684C17.8918 9.1021 18.1082 9.1021 18.309 9.03684C18.5373 8.96265 18.7354 8.76465 19.1314 8.36863L21.5893 5.91072C21.854 6.55488 22 7.26039 22 8C22 11.0376 19.5376 13.5 16.5 13.5C16.1338 13.5 15.7759 13.4642 15.4298 13.3959C14.9436 13.3001 14.7005 13.2521 14.5532 13.2668C14.3965 13.2824 14.3193 13.3059 14.1805 13.3802C14.0499 13.4501 13.919 13.581 13.657 13.843L6.5 21C5.67157 21.8284 4.32843 21.8284 3.5 21C2.67157 20.1716 2.67157 18.8284 3.5 18L10.657 10.843C10.919 10.581 11.0499 10.4501 11.1198 10.3195C11.1941 10.1807 11.2176 10.1035 11.2332 9.94681C11.2479 9.79945 11.1999 9.55638 11.1041 9.07024C11.0358 8.72406 11 8.36621 11 8C11 4.96243 13.4624 2.5 16.5 2.5C17.5055 2.5 18.448 2.76982 19.259 3.24101ZM12.0001 15.4999L17.5 20.9999C18.3284 21.8283 19.6716 21.8283 20.5 20.9999C21.3284 20.1715 21.3284 18.8283 20.5 17.9999L15.9753 13.4753C15.655 13.445 15.3427 13.3872 15.0408 13.3043C14.6517 13.1975 14.2249 13.2751 13.9397 13.5603L12.0001 15.4999Z",
    stroke: "#A459FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTool02);
export default __webpack_public_path__ + "static/media/tool-02.6657bf3cd8acaa4ae1517b72a6b40598.svg";
export { ForwardRef as ReactComponent };